module.exports = __webpack_public_path__ + "img/appointment_icon.22091e90.svg";